module.exports = __webpack_public_path__ + "assets/redo-mobile.daf98050.svg";